import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, Pagination } from 'swiper'
import "swiper/css"
import "swiper/css/autoplay"
import "swiper/css/pagination"

import {map, forEach} from 'lodash'
import { Navigation } from "swiper"

export default ({data}) => {
  return (
    <div className="w-full announcement-container text-left">
      <div className="mb-8 text-base text-sky-700 font-bold uppercase">Announcements</div>
      <Swiper
        modules={[Autoplay, Pagination]}
        pagination={{clickable: true}}
        className="mySwiper"
        autoplay={{delay: 5000}}
        loop={true}
        speed={500}
      >
        {
          map(data, (announcement, index) => {
            return (
              <SwiperSlide key={`announcement-${index}`}>
                <div className="text-left w-full tracking-normal">
                  <h2 className="text-sky-500 block uppercase mb-2">{announcement.headline}</h2>
                  <div dangerouslySetInnerHTML={{__html: announcement.body}} className="font-normal h-[100px]"></div>
                </div>
              </SwiperSlide>
            )
          })
        }
      </Swiper>
    </div>
  )
}